export const canDownloadApiData = (run, unavailableIds) =>
  Boolean(run?.api_data_csv_s3_key) &&
  run.status !== 'running' &&
  !unavailableIds?.[`${run.id}:api-data`]

export const apiDataUnavailableReason = (run) => {
  if (!run) return 'No run to download'
  if (run.status === 'running') return 'CSV is available after the run finishes'
  if (!run.api_data_csv_s3_key) return 'CSV expires after 7 days'
  return 'CSV is no longer available'
}
